
import { Vue, Component } from 'vue-property-decorator';
import {
  Popup,
  Button,
  Swipe,
  SwipeItem,
  Icon,
  ImagePreview,
  Toast,
} from 'vant';
import html2canvas from 'html2canvas';
import { getWorkDetail, getPV, buyInfo } from '../api/index';
import * as config from '../config';
import Poster from '../components/Poster.vue';
import VoteButton from '@/components/next/VoteButton.vue';
import Canvas from '../components/Canvas.vue';
Vue.use(Popup).use(Button);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Icon);
Vue.use(ImagePreview);

@Component({
  name: 'WorkDetail',
  components: {
    Poster,
    VoteButton,
    Canvas,
  },
})
export default class WorkDetail extends Vue {
  options = config.OPTHINES;
  showCanvas = false;
  images = [];
  videos = [];
  PV: number = 0;
  detailData: any = {};
  imgInstance: any = '';

  get id() {
    return this.$route.query.id;
  }

  created() {
    this.fetchDetail();
    this.fetchPV();
  }

  async fetchDetail() {
    const ret = await getWorkDetail(this.id as string);
    this.detailData = ret.data;
    this.images = ret.data.pictures;
    this.videos = ret.data.videos;
  }
  async fetchPV() {
    const ret = await getPV();
    this.PV = ret.data;
  }
  // 显示图片
  handlePicShow(index: number) {
    this.imgInstance = ImagePreview({
      images: this.images,
      startPosition: index,
      closeable: true,
    });
  }
  votSuccess(data: string | number) {
    this.detailData.votes = data;
  }
  backRoute() {
    if (window.history.length <= 1) {
      this.$router.push('index');
    } else {
      this.$router.go(-1);
    }
  }
  // 购买按钮
  async buyBtn() {
    const res: any = await buyInfo(this.id as string);
    if (res.code === 200) {
      window.location.href = res.data[0].goods_url;
    } else {
      Toast(res.msg);
    }
  }
  toSharePage() {
    this.$router.push({
      path: 'SharePage',
      query: {
        id: this.id,
      },
    });
  }
  beforeRouteLeave(to: any, from: any, next: any) {
    if (this.imgInstance && this.imgInstance.close) {
      this.imgInstance.close();
    }
    next();
  }
}
